import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "booking-for-others" }
const _hoisted_2 = { class: "form-check" }
const _hoisted_3 = ["name", "checked", "disabled", "onChange", "onBlur"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  class: "btn-group w-100",
  role: "group"
}
const _hoisted_7 = ["name", "checked", "disabled", "onChange", "onBlur"]
const _hoisted_8 = ["name", "checked", "disabled", "onChange", "onBlur"]
const _hoisted_9 = ["name", "checked", "disabled", "onChange", "onBlur"]
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "position-relative" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "position-absolute top-50 end-0 translate-middle-y me-3"
}
const _hoisted_14 = {
  key: 1,
  class: "dropdown-menu show w-100 mt-1",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_17 = { class: "fw-semibold" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = {
  key: 0,
  class: "fas fa-check text-primary"
}
const _hoisted_20 = {
  key: 0,
  class: "dropdown-item-text text-muted"
}
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_22 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_23 = { class: "selected-person-card" }
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_25 = { class: "fw-semibold" }
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = ["name", "checked", "disabled", "onChange", "onBlur"]

import { ref, computed, watch, onMounted, nextTick } from "vue";
import { useMasterDataHelpers } from "../composables/useMasterDataHelpers";
import { useDebounce } from "../composables/useDebounce";


export default {
  __name: 'BookingForOthers',
  props: {
	form: {
		type: Object,
		required: true,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	modalVisible: {
		type: Boolean,
		default: false,
	},
},
  setup(__props) {

const props = __props;

// Use master data helpers for permissions
const masterData = useMasterDataHelpers();
const canBookWithoutFunds = computed(
	() => masterData.canBookWithoutTransaction.value
);
const canManageOtherBookings = computed(
	() => masterData.canManageOtherBookings.value
);

// Local state
const searchQuery = ref("");
const searchResults = ref([]);
const selectedPerson = ref(null);
const loading = ref(false);
const showDropdown = ref(false);

// API URLs from DOM
const studentSearchUrl = ref(null);
const employeeSearchUrl = ref(null);

// Initialize component
onMounted(() => {
	// Get API URLs from DOM
	studentSearchUrl.value =
		document.getElementById("vue-container")?.dataset.studentSearchApiUrl;
	employeeSearchUrl.value =
		document.getElementById("vue-container")?.dataset.employeeSearchApiUrl;
});

// Reset component state helper function
function resetComponentState() {
	selectedPerson.value = null;
	searchQuery.value = "";
	searchResults.value = [];
	loading.value = false;
	showDropdown.value = false;
}

// Initialize search query from form state
function initializeFromFormState() {
	const formValues = props.form.state.values;
	
	// Set search query from form state if we have a selected person
	if (formValues.selectedPersonName) {
		searchQuery.value = formValues.selectedPersonName;
	}
}

// Debounce search
const { debounce } = useDebounce();
const debouncedSearch = debounce(searchPersons, 300);

// Methods
function handleCreateForOtherChange(field, event) {
	const checked = event.target.checked;
	field.handleChange(checked);

	// If unchecking, clear related fields and reset to default state
	if (!checked) {
		clearSelection();
		try {
			if (props.form?.setFieldValue) {
				props.form.setFieldValue("personType", "student");
				props.form.setFieldValue("bookWithoutFunds", false);
			}
		} catch (error) {
			console.warn("Failed to clear related fields:", error);
		}
	}

	// Force validation update for selectedPersonId field
	try {
		const selectedPersonIdField = props.form.getFieldInfo("selectedPersonId");
		if (selectedPersonIdField) {
			selectedPersonIdField.validate("change");
		}
	} catch (error) {
		console.warn("Failed to trigger validation:", error);
	}
}

function handlePersonTypeChange(field, personType) {
	field.handleChange(personType);

	// Clear selection when switching person type
	clearSelection();

	// If switching to student and a person is already selected, clear series fields
	if (personType === "student" && selectedPerson.value) {
		try {
			if (props.form?.setFieldValue) {
				props.form.setFieldValue("rrulePattern", "");
				props.form.setFieldValue("cancelledDates", []);
			}
		} catch (error) {
			console.warn("Failed to clear series fields:", error);
		}
	}

	// Handle validation for selectedPersonId field based on person type
	try {
		const selectedPersonIdField = props.form.getFieldInfo("selectedPersonId");
		if (selectedPersonIdField) {
			if (personType === "unpersonalized") {
				// Clear any validation errors when switching to unpersonalized
				selectedPersonIdField.setMeta((prev) => ({
					...prev,
					errors: [],
					errorMap: {},
				}));
			} else {
				// Trigger validation when switching to student/employee
				selectedPersonIdField.validate("change");
			}
		}
	} catch (error) {
		console.warn("Failed to handle validation:", error);
	}
}

function handleSearchInput() {
	if (searchQuery.value.trim()) {
		debouncedSearch();
	} else {
		searchResults.value = [];
	}
}

async function searchPersons() {
	if (searchQuery.value.trim().length <= 1) {
		searchResults.value = [];
		return;
	}

	loading.value = true;

	try {
		const personType = props.form.state.values.personType;
		const searchUrl =
			personType === "student"
				? studentSearchUrl.value
				: employeeSearchUrl.value;

		if (!searchUrl) {
			console.error("Search URL not available");
			return;
		}

		const url = `${searchUrl}?q=${encodeURIComponent(searchQuery.value)}`;

		const response = await fetch(url, {
			method: "GET",
			headers: {
				Accept: "application/json",
			},
			credentials: "same-origin",
		});

		if (!response.ok) {
			throw new Error(`Search failed: ${response.status}`);
		}

		const data = await response.json();

		searchResults.value = (data.items || []).map((item) => ({
			id: item.id,
			name: item.name,
			number: personType === 'student' ? item.studentId : item.employeeNumberWWU,
			type: personType,
		}));
	} catch (error) {
		console.error("Search error:", error);
		searchResults.value = [];
	} finally {
		loading.value = false;
	}
}

function selectPerson(person, field) {
	selectedPerson.value = person;
	searchQuery.value = person.name;
	showDropdown.value = false;
	field.handleChange(person.id);

	// Store person details in form state for persistence through error flows
	try {
		if (props.form?.setFieldValue) {
			props.form.setFieldValue("selectedPersonName", person.name);
			props.form.setFieldValue("selectedPersonIdForDisplay", person.number);
		}
	} catch (error) {
		console.warn("Failed to store person details in form:", error);
	}

	// If selecting a student, clear series pattern immediately
	if (person.type === "student") {
		try {
			if (props.form?.setFieldValue) {
				props.form.setFieldValue("rrulePattern", "");
				props.form.setFieldValue("cancelledDates", []);
			}
		} catch (error) {
			console.warn("Failed to clear series fields:", error);
		}
	}
}

function clearSelection() {
	resetComponentState();
	try {
		if (props.form?.setFieldValue) {
			props.form.setFieldValue("selectedPersonId", "");
			props.form.setFieldValue("selectedPersonName", "");
			props.form.setFieldValue("selectedPersonIdForDisplay", "");
		}
	} catch (error) {
		console.warn("Failed to clear selectedPerson fields:", error);
	}
}

// Watch for person type changes to clear selection
watch(
	() => props.form.state?.values?.personType,
	(newType) => {
		clearSelection();
		if (newType !== "student") {
			try {
				if (props.form?.setFieldValue) {
					props.form.setFieldValue("bookWithoutFunds", false);
				}
			} catch (error) {
				console.warn("Failed to set bookWithoutFunds:", error);
			}
		}
	}
);

// Watch createForOther changes to clear selection
watch(
	() => props.form.state?.values?.createForOther,
	(newValue) => {
		if (!newValue) {
			clearSelection();
			try {
				if (props.form?.setFieldValue) {
					props.form.setFieldValue("bookWithoutFunds", false);
				}
			} catch (error) {
				console.warn("Failed to clear bookWithoutFunds:", error);
			}
		}
	}
);


// Watch for modal visibility changes to initialize from form state
watch(
	() => props.modalVisible,
	(isVisible, wasVisible) => {
		// When modal becomes visible, initialize from form state
		if (isVisible && !wasVisible) {
			resetComponentState();
			// Initialize search query from form state
			nextTick(() => {
				initializeFromFormState();
			});
		}
	}
);

// Close dropdown when clicking outside
function handleClickOutside(event) {
	const bookingForOthersEl = event.target.closest(".booking-for-others");
	if (!bookingForOthersEl) {
		showDropdown.value = false;
	}
}

// Add/remove click outside listener
watch(showDropdown, (show) => {
	if (show) {
		document.addEventListener("click", handleClickOutside);
	} else {
		document.removeEventListener("click", handleClickOutside);
	}
});

// Extract form instance for template
const { form } = props;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Create for somebody else "),
    _createVNode(_unref(form).Field, { name: "createForOther" }, {
      default: _withCtx(({ field }) => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
              id: "createForOther",
              name: field.name,
              checked: !!field.state.value,
              type: "checkbox",
              class: "form-check-input",
              disabled: __props.disabled,
              onChange: $event => (handleCreateForOtherChange(field, $event)),
              onBlur: field.handleBlur
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: "createForOther",
              class: "form-check-label"
            }, " Für jemand anderen erstellen ", -1 /* CACHED */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Use TanStack Form Subscribe for reactive UI updates "),
    _createVNode(_unref(form).Subscribe, null, {
      default: _withCtx(({ values }) => [
        (values.createForOther)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createCommentVNode(" Hidden field to ensure selectedPersonId is valid when unpersonalized "),
              (values.personType === 'unpersonalized')
                ? (_openBlock(), _createBlock(_unref(form).Field, {
                    key: 0,
                    name: "selectedPersonId",
                    validators: {
              onChange: () => undefined,
              onSubmit: () => undefined,
            }
                  }, {
                    default: _withCtx(() => [
                      _createCommentVNode(" Hidden field, no UI ")
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Person Type Selection "),
              _createVNode(_unref(form).Field, { name: "personType" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label" }, "Person Typ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("input", {
                        id: "personTypeStudent",
                        name: field.name,
                        checked: field.state.value === 'student',
                        type: "radio",
                        class: "btn-check",
                        value: "student",
                        disabled: __props.disabled,
                        onChange: () => handlePersonTypeChange(field, 'student'),
                        onBlur: field.handleBlur
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7),
                      _createElementVNode("label", {
                        for: "personTypeStudent",
                        class: _normalizeClass(["btn btn-outline-primary", { active: field.state.value === 'student' }])
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "fas fa-user-graduate me-1" }, null, -1 /* CACHED */),
                        _createTextVNode(" Student ", -1 /* CACHED */)
                      ]))], 2 /* CLASS */),
                      _createElementVNode("input", {
                        id: "personTypeEmployee",
                        name: field.name,
                        checked: field.state.value === 'employee',
                        type: "radio",
                        class: "btn-check",
                        value: "employee",
                        disabled: __props.disabled,
                        onChange: () => handlePersonTypeChange(field, 'employee'),
                        onBlur: field.handleBlur
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8),
                      _createElementVNode("label", {
                        for: "personTypeEmployee",
                        class: _normalizeClass(["btn btn-outline-primary", { active: field.state.value === 'employee' }])
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "fas fa-user-tie me-1" }, null, -1 /* CACHED */),
                        _createTextVNode(" Mitarbeiter ", -1 /* CACHED */)
                      ]))], 2 /* CLASS */),
                      (canManageOtherBookings.value)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            id: "personTypeUnpersonalized",
                            name: field.name,
                            checked: field.state.value === 'unpersonalized',
                            type: "radio",
                            class: "btn-check",
                            value: "unpersonalized",
                            disabled: __props.disabled,
                            onChange: 
                      () => handlePersonTypeChange(field, 'unpersonalized')
                    ,
                            onBlur: field.handleBlur
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9))
                        : _createCommentVNode("v-if", true),
                      (canManageOtherBookings.value)
                        ? (_openBlock(), _createElementBlock("label", {
                            key: 1,
                            for: "personTypeUnpersonalized",
                            class: _normalizeClass(["btn btn-outline-primary", { active: field.state.value === 'unpersonalized' }])
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "fas fa-building me-1" }, null, -1 /* CACHED */),
                            _createTextVNode(" Ohne Personenbezug ", -1 /* CACHED */)
                          ]))], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createCommentVNode(" Person Search "),
              (values.personType !== 'unpersonalized')
                ? (_openBlock(), _createBlock(_unref(form).Field, {
                    key: 1,
                    name: "selectedPersonId",
                    validators: {
              onChange: ({ value, fieldApi }) => {
                const createForOther =
                  fieldApi.form.getFieldValue('createForOther');
                const personType = fieldApi.form.getFieldValue('personType');
                // Only validate if createForOther is true and not unpersonalized
                return createForOther &&
                  personType !== 'unpersonalized' &&
                  !value
                  ? 'Bitte wählen Sie eine Person aus'
                  : undefined;
              },
              onSubmit: ({ value, fieldApi }) => {
                const createForOther =
                  fieldApi.form.getFieldValue('createForOther');
                const personType = fieldApi.form.getFieldValue('personType');
                // Only validate if createForOther is true and not unpersonalized
                return createForOther &&
                  personType !== 'unpersonalized' &&
                  !value
                  ? 'Bitte wählen Sie eine Person aus'
                  : undefined;
              },
            }
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", {
                          for: "personSearch",
                          class: "form-label"
                        }, [
                          _createTextVNode(" Person suchen "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            id: "personSearch",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((searchQuery).value = $event)),
                            type: "text",
                            class: _normalizeClass(["form-control", {
                      'is-invalid': field.state.meta.errors.length > 0,
                    }]),
                            placeholder: "Name oder E-Mail eingeben...",
                            disabled: __props.disabled,
                            onInput: handleSearchInput,
                            onFocus: _cache[1] || (_cache[1] = $event => (showDropdown.value = true))
                          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_12), [
                            [_vModelText, searchQuery.value]
                          ]),
                          _createCommentVNode(" Loading indicator "),
                          (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("div", {
                                  class: "spinner-border spinner-border-sm",
                                  role: "status"
                                }, [
                                  _createElementVNode("span", { class: "visually-hidden" }, "Wird geladen...")
                                ], -1 /* CACHED */)
                              ]))]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Search Results Dropdown "),
                          (
                      showDropdown.value &&
                        (searchResults.value.length > 0 || (searchQuery.value && !loading.value))
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (person) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: person.id,
                                    type: "button",
                                    class: _normalizeClass(["dropdown-item", { active: person.id === field.state.value }]),
                                    onClick: $event => (selectPerson(person, field))
                                  }, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_17, _toDisplayString(person.name), 1 /* TEXT */),
                                        _createElementVNode("small", _hoisted_18, _toDisplayString(person.number), 1 /* TEXT */)
                                      ]),
                                      (person.id === field.state.value)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ], 10 /* CLASS, PROPS */, _hoisted_15))
                                }), 128 /* KEYED_FRAGMENT */)),
                                (
                        searchQuery.value && searchResults.value.length === 0 && !loading.value
                      )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(searchQuery.value.length > 1
                          ? 'Keine Ergebnisse gefunden'
                          : 'Mindestes zwei Zeichen erforderlich'), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (field.state.meta.errors.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(field.state.meta.errors[0]), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["validators"]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Selected Person Display "),
              (
              values.selectedPersonName &&
                values.personType !== 'unpersonalized'
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_25, [
                            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-user-check text-success me-2" }, null, -1 /* CACHED */)),
                            _createTextVNode(" " + _toDisplayString(values.selectedPersonName), 1 /* TEXT */)
                          ]),
                          _createElementVNode("small", _hoisted_26, _toDisplayString(values.selectedPersonIdForDisplay || 'Keine E-Mail verfügbar'), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-outline-danger",
                          disabled: __props.disabled,
                          onClick: clearSelection
                        }, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_27)
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Book without funds option (only for students) "),
              _createVNode(_unref(form).Field, { name: "bookWithoutFunds" }, {
                default: _withCtx(({ field }) => [
                  (
                  values.personType === 'student' &&
                    canBookWithoutFunds.value &&
                    values.selectedPersonName
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("input", {
                            id: "bookWithoutFunds",
                            name: field.name,
                            checked: field.state.value,
                            type: "checkbox",
                            class: "form-check-input",
                            disabled: __props.disabled,
                            onChange: (e) => field.handleChange(e.target.checked),
                            onBlur: field.handleBlur
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_30),
                          _cache[11] || (_cache[11] = _createElementVNode("label", {
                            for: "bookWithoutFunds",
                            class: "form-check-label"
                          }, [
                            _createElementVNode("i", { class: "fas fa-money-bill-wave text-warning me-1" }),
                            _createTextVNode(" Buchung ohne Belastung des Kontingents ")
                          ], -1 /* CACHED */))
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("small", { class: "text-muted d-block mt-1" }, " Die Buchung wird ohne Abzug vom Stundenkontingent des Studenten erstellt. ", -1 /* CACHED */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

}